
eval("define(\'text!orodatagrid/templates/board/card-view.html\',[],function () { return \'<span>\\n    Generic card\\n    <% (console && console.warn && console.warn(\\\'Please configure `card_view` in datagrid board configuration\\\')) %>\\n</span>\\n\';});\n\n//# sourceURL=/text!orodatagrid/templates/board/card-view.html");

